import { useAppSettingStore } from '../store/app-store';
import { useAuth } from './use-auth';
import { ApiInstance, UserAssetsInfoParams } from '@/libs/sdk/api';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

export const useSignedUserAssets = (api: ApiInstance, params?: UserAssetsInfoParams) => {
  const { data } = useAuth();
  const uid = data?.uid;
  const baseToken = useAppSettingStore(state => state.baseToken);
  const { baseTokenAddress = baseToken.address } = params || {};
  const query = useQuery({
    enabled: !!uid,
    queryKey: ['SignedUserAssets', api, uid, baseTokenAddress, params],
    queryFn: async () => {
      const { data } = await api.market.getUserAssetsInfo({ ...params, uid: uid!, baseTokenAddress });
      return data;
    },
  });
  useEffect(() => {
    if (!query.isEnabled) return;
    const reftch = () => query.refetch({ cancelRefetch: false });
    api.sse.addEventListener('user:asset_changed', reftch);
    return () => {
      api.sse.removeEventListener('user:asset_changed', reftch);
    };
  }, [query.isEnabled, api.sse]);
  return query;
};
